/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

// The following flags will work for all browsers.

(window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
(window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
// (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

// in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
// with the following flag, it will bypass `zone.js` patch for IE/Edge

(window as any).__Zone_enable_cross_context_check = true;

let props = [
	'scroll',
	'mouseenter',
	'mouseleave',
	'mousemove',
	'mouseover',
	'mouseout',
	'mousewheel',
	'pointermove',
];
let canvasProps = [
	'scroll',
	'mouseenter',
	'mouseleave',
	'mousemove',
	'mouseover',
	'mouseout',
	'mousewheel',
	'pointermove',
	'pointerover',
	'pointerleave',
	'pointerdown',
];
// black list scroll event handler for onProp
const targets = [window, Document.prototype, HTMLBodyElement.prototype, HTMLElement.prototype];
window.__Zone_ignore_on_properties = [];
targets.forEach(function (target) {
	window.__Zone_ignore_on_properties.push({
		target,
		ignoreProperties: canvasProps,
	});
});

//looks like __zone_symbol__BLACK_LISTED_EVENTS was changed to __zone_symbol__UNPATCHED_EVENTS at some point, so do both for now
window.__zone_symbol__BLACK_LISTED_EVENTS = canvasProps;
(window as any).__zone_symbol__UNPATCHED_EVENTS = canvasProps; // disable patch specified eventNames
